import styled from "styled-components"

const StyledStripeContent = styled.div`
	width: 56px;
	height: 20px;
	display: flex;
	justify-content: space-between;
`

const StyledStripe = styled.div`
	width: 12px;
	height: 20px;
	background: var(--primary);
`

const Stripe = () => (
        <StyledStripeContent>
            <StyledStripe />
            <StyledStripe />
            <StyledStripe />
        </StyledStripeContent>
	)

export default Stripe

